import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import queryKeys from '../query-keys'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useUpdateDetail, {
  UseUpdateDetailOptions,
} from '../core-hooks/useUpdateDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateList, {
  UseUpdateListOptions,
} from '../core-hooks/useUpdateList'
import useDeleteList, {
  UseDeleteListOptions,
} from '../core-hooks/useDeleteList'
import buildService from '../create-service'
import { InfoTypeNamespace } from '@/types/info-types'

const service = buildService<InfoTypeNamespace>({
  pathCategory: 'info_type_namespaces',
})

export function useGetInfoTypeNamespace({
  id,
  ...options
}: UseGetDetailOptions<InfoTypeNamespace>) {
  const query = useGetDetail<InfoTypeNamespace>({
    id,
    queryKey: queryKeys.infoTypeNamespaces.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    infoTypeNamespace: query.data,
    ...query,
  }
}

export function useCreateInfoTypeNamespace(
  options: UseCreateDetailOptions<InfoTypeNamespace> = {},
) {
  const mutation = useCreateDetail<InfoTypeNamespace>({
    serviceFn: service.createDetail,
    ...options,
  })

  return {
    createInfoTypeNamespace: mutation.mutateAsync,
    ...mutation,
  }
}

export function useUpdateInfoTypeNamespace(
  options: UseUpdateDetailOptions<InfoTypeNamespace> = {},
) {
  const mutation = useUpdateDetail<InfoTypeNamespace>({
    serviceFn: service.updateDetail,
    ...options,
  })

  return {
    updateInfoTypeNamespace: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeleteInfoTypeNamespace(
  options: UseDeleteDetailOptions = {},
) {
  const mutation = useDeleteDetail<InfoTypeNamespace>({
    serviceFn: service.deleteDetail,
    ...options,
  })

  return {
    deleteInfoTypeNamespace: mutation.mutateAsync,
    ...mutation,
  }
}

export function useGetInfoTypeNamespaces({
  filters,
  ...options
}: UseGetListOptions<InfoTypeNamespace> = {}) {
  const query = useGetList<InfoTypeNamespace>({
    filters,
    queryKey: queryKeys.infoTypeNamespaces.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    infoTypeNamespaces: query.allData,
    ...query,
  }
}

export function useUpdateInfoTypeNamespaces(
  options: UseUpdateListOptions<InfoTypeNamespace> = {},
) {
  const mutation = useUpdateList<InfoTypeNamespace>({
    serviceFn: service.updateList,
    ...options,
  })

  return {
    updateInfoTypeNamespaces: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeleteInfoTypeNamespaces({
  sideEffectQueryKeys,
  listQueryKey,
  ...options
}: UseDeleteListOptions = {}) {
  const mutation = useDeleteList<InfoTypeNamespace>({
    serviceFn: service.deleteList,
    sideEffectQueryKeys,
    listQueryKey,
    ...options,
  })

  return {
    deleteInfoTypeNamespaces: mutation.mutateAsync,
    ...mutation,
  }
}
